import styled, { css } from 'styled-components'

type CustomAvatarProps = {
  height: number
  width: number
}

export const CustomAvatar = styled.div<CustomAvatarProps>`
  border-radius: 100px;
  background-color: ${({ theme }) => theme.colors.avatar};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ height, width }) => css`
    height: ${height}px;
    width: ${width}px;
  `}
`

export const AvatarLetter = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-size: 24px;
`
